import { LinkBankAccountForm } from '@/onboarding/features/bank-account/components/LinkBankAccountForm'
import { APP_ROUTES } from '@/common/constants'
import OnboardingAddBankAccountSubmittedAnalytics from '@/common/analytics/events/OnboardingAddBankAccountAnalytics'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { Helmet } from 'react-helmet'
import { APP } from '@/common/strings'
import { useBankAccountLogic } from './features/bank-account/useBankAccountLogic'
import { useOnboardingProgress } from './useOnboardingProgress'
import { FullScreenLoader } from '@/common/ui/FullScreenLoader'

/** Production page — wires useBankAccountLogic result to BankAccountPageIntrinsic.
 *  Navigation guards are kept here (not in the hook) since they are route concerns, not business logic.
 */
export function BankAccountPage() {
    const navigate = useNavigate()
    const { progress } = useOnboardingProgress()
    const logic = useBankAccountLogic()

    // Guard 1: If bank account already exists → skip form (original behavior preserved)
    useEffect(() => {
        if (!logic.data || logic.loading) return
        navigate(APP_ROUTES.DASHBOARD)
    }, [logic.data, logic.loading, navigate])

    // Guard 2: On successful submit → track + navigate (uses isSuccess to distinguish "never submitted" from "just succeeded")
    useEffect(() => {
        if (!logic.isSuccess || logic.saving) return
        OnboardingAddBankAccountSubmittedAnalytics.track()
        navigate(APP_ROUTES.DASHBOARD)
    }, [logic.isSuccess, logic.saving, navigate])

    // Show loading while checking guards to prevent flash of form before redirect
    if (logic.loading) {
        return <FullScreenLoader />
    }

    return (
        <>
            <Helmet>
                <title>Bank Account | {APP.title}</title>
            </Helmet>
            <LinkBankAccountForm
                progress={progress}
                defaultValues={logic.data}
                loading={logic.loading}
                saving={logic.saving}
                onSubmit={logic.onSubmit}
            />
        </>
    )
}
